import * as React from "react";
function SvgIcChevronDoubleRight(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12.649 19.087L12 18.712l3.85-6.669L12 5.375 12.649 5l4.068 7.043-4.068 7.044z"
        fill="currentColor"
      />
      <path
        d="M8.649 19.087L8 18.712l3.85-6.669L8 5.375 8.649 5l4.068 7.043-4.068 7.044z"
        fill="currentColor"
      />
    </svg>
  );
}
export default SvgIcChevronDoubleRight;
